import React, { useState, useReducer, useEffect } from "react"
import { useSnackbar } from "notistack"
import { useRecoilState } from "recoil"
import currentAssociation from "../../store/currentAssociation"
// import currentUser from "../../store/currentUser"
import { Storage, API, graphqlOperation } from "aws-amplify"
import {
  createDocument as CreateDocument,
  createFile as CreateFile,
} from "../../graphqlCustom/mutations"
import { listDocuments, listFiles } from "../../graphqlCustom/queries"
import { onCreateDocumentPool } from "../../graphqlCustom/subscriptions"
import { v4 as uuid } from "uuid"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Collapse from "@material-ui/core/Collapse"
import Grid from "@material-ui/core/Grid"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import Link from "@material-ui/core/Link"
import AddIcon from "@material-ui/icons/Add"
import DeleteIcon from "@material-ui/icons/Delete"
import UploadIcon from "@material-ui/icons/CloudUpload"

import Accordions from "../../components/Accordions"
import Action from "../../components/Action"
import Button from "../../components/Button"
import FormContainer from "../../components/FormContainer"
import TextAreaField from "../../components/TextAreaField"
import TextField from "../../components/TextField"

import config from "../../aws-exports"

const { aws_user_files_s3_bucket_region: region, aws_user_files_s3_bucket: bucket } = config

const useStyles = makeStyles((theme) => ({
  addButton: {
    float: "right",
    marginBottom: theme.spacing(5),
  },
  fileFooter: {
    textAlign: "center",
  },
  files: {},
  root: {
    clear: "both",
  },
  submit: {
    float: "right",
    margin: theme.spacing(1),
  },
  formTitle: {
    paddingLeft: theme.spacing(2),
    margin: 0,
  },
}))

// const documentsType = "meeting"
// const authorId = uuid()
const initialState = {
  documents: [],
}

const getFilenameFromPath = (str) => {
  return str.split("\\").pop().split("/").pop()
}

function reducer(state, action) {
  switch (action.type) {
    case "SET_DOCUMENTS":
      return { ...state, documents: action.documents }
    case "ADD_DOCUMENT":
      return { ...state, documents: [action.document, ...state.documents] }
    default:
      return state
  }
}

export default function DocumentsLists({ documentsType, ...props }) {
  const theme = useTheme()
  const classes = useStyles()
  const { enqueueSnackbar } = useSnackbar()
  const [fileFields, setFileFields] = useState([{ title: "", filename: "", upload: [] }])
  const [fields, setFields] = useState({ title: "", notes: "" })
  const [open, setOpen] = useState(false)
  const [state, dispatch] = useReducer(reducer, initialState)

  const [association] = useRecoilState(currentAssociation)
  // const [user] = useRecoilState(currentUser)

  useEffect(() => {
    async function fetchDocuments() {
      try {
        const documents = await API.graphql(
          graphqlOperation(listDocuments, {
            limit: 200,
            sortDirection: "DESC",
            associationId: association.id,
            typeCreatedAt: {
              beginsWith: {
                type: documentsType,
              },
            },
          })
        )
        dispatch({ type: "SET_DOCUMENTS", documents: documents.data.listDocuments.items })
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar(`Error fetching documents`, {
          variant: "error",
        })
      }
    }
    fetchDocuments()

    const subscription = API.graphql(graphqlOperation(onCreateDocumentPool)).subscribe({
      next: async (documentData) => {
        const { onCreateDocumentPool: document } = documentData.value.data
        if (document) {
          if (!document.files || !document.files[0]) {
            const documentFiles = await API.graphql(
              graphqlOperation(listFiles, {
                filter: {
                  parentId: {
                    eq: document.id,
                  },
                },
              })
            )
            const { listFiles: newFilesList } = documentFiles.data
            if (newFilesList) {
              document.files = newFilesList
            }
          }
          dispatch({ type: "ADD_DOCUMENT", document: document })
        }
      },
    })
    return () => subscription.unsubscribe()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [association, documentsType])

  const onChange = (e) => {
    setFields({
      ...fields,
      [e.target.name]: e.target.value,
    })
  }

  const addFileField = (e) => {
    setFileFields([...fileFields, { title: "", filename: "", upload: [] }])
  }

  const onFileChange = (event, name, index) => {
    let newRow = fileFields[index]
    const {
      target: { value, files },
    } = event
    newRow[name] = value
    if (files) {
      const [file] = files || []
      newRow.upload = file
    }
    setFileFields([...fileFields.slice(0, index), newRow, ...fileFields.slice(index + 1)])
  }

  const onFileDelete = (index) => {
    setFileFields([...fileFields.slice(0, index), ...fileFields.slice(index + 1)])
  }

  const toggleForm = () => {
    setOpen(!open)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    createDocument()
  }

  async function createFile(fileField, documentId) {
    if (!fileField.upload) {
      console.log("No file upload")
      return
    }
    const { name: fileName, type: mimeType } = fileField.upload
    const ext = fileName.split(".").pop()
    const key = `${uuid()}.${ext}` // `${association.id}/${documentsType}/${uuid()}.${ext}` //
    const fileForUpload = {
      bucket,
      key,
      region,
    }
    const inputData = {
      associationId: association.id,
      // authorId: user.id,
      file: fileForUpload,
      parentId: documentId,
      // fileDocumentId: documentId,
      title: fileField.title || fileName,
    }
    // try {
    await Storage.put(key, fileField.upload, {
      contentType: mimeType,
      // level: "private",
    })
    await API.graphql(graphqlOperation(CreateFile, { input: inputData }))
    // return true
    // } catch (error) {
    //   console.log("Error: ", error)
    //   enqueueSnackbar(error.message, {
    //     variant: "error",
    //   })
    //   return false
    // }
  }

  async function createDocument() {
    if (!fields.title) return alert("Please add a title")

    if (fileFields && fields.title) {
      const documentId = uuid()
      const documentData = {
        id: documentId,
        associationId: association.id,
        // authorId: user.id,
        content: fields.notes,
        title: fields.title,
        type: documentsType,
      }

      try {
        // Add the children files
        for (var i = 0, l = fileFields.length; i < l; i++) {
          if (fileFields[i].filename) {
            //fileFields[i].title &&
            // const fileCreated =
            await createFile(fileFields[i], documentId)
            // if (!fileCreated) {
            //   throw new Error(`Could not upload file: ${fileFields[i].upload.name}`)
            // }
          }
        }

        // Add the document
        await API.graphql(graphqlOperation(CreateDocument, { input: documentData }))

        // Reset form
        setFields({ title: "", notes: "" })
        setFileFields([{ title: "", filename: "", upload: [] }])
        setOpen(false)

        enqueueSnackbar("Document added", {
          variant: "success",
        })
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar("There was a problem adding the document", {
          variant: "error",
        })
      }
    }
  }

  return (
    <>
      <Collapse in={!open} timeout={theme.transitions.duration.shorter}>
        <Action onClick={toggleForm} className={classes.addButton} variant="extended">
          <AddIcon />
          Document
        </Action>
      </Collapse>
      <Collapse in={open}>
        <FormContainer>
          <form
            className={classes.form}
            onSubmit={(e) => {
              e.preventDefault()
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <h3 className={classes.formTitle}>Add Document</h3>
              </Grid>
              <Grid item xs={12}>
                <TextField name="title" label="Name" value={fields.title} onChange={onChange} />
              </Grid>
              <Grid item xs={12}>
                <TextAreaField
                  name="notes"
                  label="Notes"
                  value={fields.notes}
                  onChange={onChange}
                />
              </Grid>
              <Grid item xs={12}>
                <h4 className={classes.formTitle}>Add Files</h4>
              </Grid>

              {fileFields.map((file, index) => {
                const titleId = `title-${index}`
                const fileId = `filename-${index}`
                return (
                  <React.Fragment key={index}>
                    <Grid item xs={6}>
                      <TextField
                        name={titleId}
                        value={file.title}
                        label="File Name"
                        style={{ margin: 0, width: "100%" }}
                        onChange={(e) => {
                          onFileChange(e, "title", index)
                        }}
                      />
                    </Grid>
                    <Grid item xs={5}>
                      <TextField
                        name={fileId}
                        label="File"
                        type="file"
                        onChange={(e) => {
                          onFileChange(e, "filename", index)
                        }}
                        style={{ margin: 0, width: "100%" }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <UploadIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                      {file.filename && (
                        <p style={{ marginTop: 5, marginBottom: 0 }}>
                          Selected: <strong>{getFilenameFromPath(file.filename)}</strong>
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={1} style={{ paddingTop: 10 }}>
                      <IconButton
                        onClick={(e) => {
                          e.preventDefault()
                          onFileDelete(index)
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </React.Fragment>
                )
              })}

              <Grid item xs={12} className={classes.fileFooter}>
                <Button
                  color="secondary"
                  startIcon={<AddIcon />}
                  onClick={addFileField}
                  variant="text"
                >
                  File
                </Button>
              </Grid>
            </Grid>
            <Button href="#text-buttons" onClick={toggleForm} variant="text">
              Cancel
            </Button>
            <Button className={classes.submit} startIcon={<AddIcon />} onClick={handleSubmit}>
              Upload
            </Button>
          </form>
        </FormContainer>
      </Collapse>
      {state.documents.length ? (
        <Accordions items={state.documents} />
      ) : (
        <h3>
          No documents yet.{" "}
          <Link href="#" onClick={toggleForm}>
            Add a document
          </Link>
        </h3>
      )}
      {/* <div>
        <h2>Documents</h2>
        {state.documents.map((document, index) => {//DocumentContent
          console.log(document)
          listFiles(document.files.items)
          return (
            <div key={index}>
              <h3>{document.title}</h3>
            </div>
          )
        })}
      </div> */}
    </>
  )
}
